export enum eDisbursementType {
  Unknown = 'Unknown',
  Wire = 'Wire',
  Check = 'Check',
  ACH = 'ACH',
  InternalTransfer = 'Internal Transfer',
}
